export default __webpack_public_path__ + "static/agency-user3-8f6339ac13c0b39e01ec9b2493348d43.png";